<template>
  <lenon-modal
    title="Assign Permissions"
    :show="permissionsModalOpened"
    size="lg"
    @onClose="closePermissionModal()"
  >
    <b-row class="align-items-start">
      <div
        v-for="(resource, index) in Object.keys(permissions)"
        :key="index"
        class="col-md-6 col-lg-4"
      >
        <b-form-checkbox
          @input="(e)=>handleAllChecked(e,resource)"
        >
          <strong>{{ resource.toUpperCase() }}</strong>
        </b-form-checkbox>

        <b-form-group>
          <b-form-checkbox-group
            v-model="selectedPermissions"
            :options="permissions[resource]"
            value-field="id"
            text-field="name"
            inline
          />
        </b-form-group>
      </div>
    </b-row>
    <template slot="modal-actions">
      <b-row class="float-right">
        <lenon-button
          variant="flat-danger"
          icon="XIcon"
          class="mr-1"
          label="Cancel"
          @onClick="closePermissionModal()"
        />
        <lenon-button
          label="Proceed"
          :disabled="selectedPermissions.length<1"
          :loading="permissionsLoading"
          loading-text="Loading..."
          @onClick="assignPermissions()"
        />
      </b-row>
    </template>
  </lenon-modal>
</template>

<script>
import LenonButton from '@/lenon/components/LenonButton.vue'
import LenonModal from '@/lenon/components/LenonModal.vue'
import {
  BRow, BFormGroup, BFormCheckboxGroup, BFormCheckbox,
} from 'bootstrap-vue'
import { ASSIGN_PERMISSIONS_TO_ROLE_M } from '@/graphql/mutations'
import showToast from '@/lenon/mixins/showToast'

export default {
  name: 'Permissions',
  components: {
    LenonModal, LenonButton, BRow, BFormGroup, BFormCheckboxGroup, BFormCheckbox,
  },
  mixins: [showToast],
  props: {
    role: { type: Object, default: () => {} },
    modalOpened: { type: Boolean, default: false },
  },
  data() {
    return {
      permissionsModalOpened: false,
      permissionsLoading: false,
      selectedPermissions: [],
    }
  },

  computed: {
    userPermissions() {
      return this.$store.getters['accountUsers/permissions']
    },
    permissions() {
      const permissions = {}
      const formatted = this.userPermissions
        .map(p => ({ id: p.id, resource: p.resource, name: this.formatPermissionName(p.name) }))
      formatted.forEach(p => {
        permissions[p.resource] = permissions[p.resource] || []
        permissions[p.resource].push({ id: p.id, name: p.name })
      })
      return permissions
    },
  },
  watch: {
    role(role) {
      if (role.permissions && role.permissions.length > 0) {
        this.selectedPermissions = role.permissions.map(p => p.id)
      } else {
        // const defaultPermissions = this.userPermissions.filter(p => [
        //   'access-dashboard-guide',
        //   'access-admin-guide',
        //   'access-academics-guide',
        //   'access-finance-guide',
        //   'access-students-guide',
        //   'access-accounts-guide',
        // ].includes(p.name)).map(p => p.id)
        this.selectedPermissions = []
      }
    },
    modalOpened(opened) {
      this.permissionsModalOpened = opened
    },
  },
  methods: {
    formatPermissionName(name) {
      return name.replaceAll('-', ' ').trim().toUpperCase()
    },
    closePermissionModal() {
      this.permissionsModalOpened = false
      this.$emit('modalClosed')
    },
    assignPermissions() {
      this.permissionsLoading = true
      this.$apollo.mutate(
        {
          mutation: ASSIGN_PERMISSIONS_TO_ROLE_M,
          variables: { input: { role_id: this.role.id, permissions: this.selectedPermissions } },
        },
      ).then(res => {
        this.permissionsLoading = false
        this.showSuccess('Permissions assigned successfully')
        this.$store.commit('accountUsers/updateRolePermissions',
          { id: this.role.id, permissions: res.data.assignPermissionToRole })
      }).catch(err => {
        this.permissionsLoading = false
        this.showError('Failed to assign permissions')
      })
    },
    handleAllChecked(checked, resource) {
      const permissions = this.permissions[resource].map(p => p.id)
      if (checked) {
        this.selectedPermissions = [...this.selectedPermissions, ...permissions]
      } else {
        this.selectedPermissions = this.selectedPermissions.filter(p => !permissions.includes(p))
      }
    },
  },
}
</script>

<style scoped>

</style>
